import { atom } from 'jotai';

/** ID for the currently selected collection */
export const collectionIdAtom = atom<string | undefined>(undefined);
